import { IItem } from '$models'
import { TenderLineUi } from './types'

export const createTenderLine = (item: IItem): TenderLineUi => ({
  lineId: crypto.randomUUID(),
  stockItemId: item.id ?? '',
  stockItemName: item.name ?? '',
  unitCost: 0,
  unitId: item.orderingUnitId ?? '',
  unitName: item.orderingUnitName ?? '',
  unitRatio: item.orderingUnitRatio ?? 1,
  brandId: item.defaultBrandId ?? '',
  brandName: '',
})
